import { useState, useEffect, useContext } from "react";
import { Table, Button, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { UserPlus, UserCheck, Send } from "lucide-react";

import { PAGE_LENGTH } from "../../config";
import {
  getUserInfo,
  getSubscriptionUserInfo,
  getPartialPhoneNumber,
} from "../../utils/utils";
import {
  submitLead,
  storeSelectedExecutive,
  getEmployeeViewableStatusUpdate,
  getEmployeeList,
} from "../../actionCreator/companyDetailsActionCreator";
import TrialModal from "../../common/TrialModal";
import ViewEmailPhoneModal from "../../common/ViewEmailPhoneModal";
import { AuthContext } from "../../context/AuthContext";
import CopyText from "../web2lead/CopyText";
import EmailForm from "../../common/EmailForm";
import copy from "../../assets/images/webToLead/copy.png";
import emailSync from "../../assets/svg/icons/send.svg";
import { useAlert } from "../../context/AlertProvider";
import addedToLead from "../../assets/svg/added-to-lead.svg";
import viewEmail from "../../assets/svg/view-email.svg";
import viewEmailChecked from "../../assets/svg/view-email-checked.svg";
import mobile from "../../assets/svg/mobile.svg";
import mobileChecked from "../../assets/svg/mobile-checked.svg";
import CustomPagination from "../../common/CustomPagination";

const KeyExecutives = () => {
  const { isAuthenticated, isEmailSetupView } = useContext(AuthContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const page = searchParams.get("page");
  const employeeList = useSelector(
    (state) => state.companyDetailsReducer.employeeList,
  );
  const submitLeadRes = useSelector(
    (state) => state.companyDetailsReducer?.executiveLeads,
  );
  const selectedDepartment = useSelector(
    (state) => state.companyDetailsReducer.selectedDepartment,
  );

  const companyDetails = useSelector(
    (state) => state.companyDetailsReducer.companyDetails,
  );
  const getEmployeeViewableData = useSelector(
    (state) => state.companyDetailsReducer?.executiveEmployeeViewableStatus,
  );
  const selectedEmployeeList = useSelector(
    (state) => state.companyDetailsReducer.selectedExecutive,
  );
  const totalCount = useSelector(
    (state) => state.companyDetailsReducer.totalCount,
  );

  const [employeeData, setEmployeeData] = useState([]);
  const [openModal, setOpenModal] = useState({
    info: null,
    open: false,
  });
  const [showEmailPhoneModal, setShowEmailPhoneModal] = useState(false);
  const [addToLeads, setAddToLeads] = useState(0);
  const [showEmail, setShowEmail] = useState({});
  const [showPhone, setShowPhone] = useState({});
  const [employeeIdsData, setEmployeeIdsData] = useState([]);

  const updateEmailStatus = async (showEmail, row) => {
    setShowEmail({ ...showEmail, [row.id]: true });
    setShowPhone({ ...showPhone, [row.id]: false });

    const res = await dispatch(
      getEmployeeViewableStatusUpdate("Email", row, selectedDepartment, page),
    );
    if (res?.status === 200) {
    } else {
      showAlert("error", res);
    }
  };
  const updatePhoneStatus = async (showPhone, row) => {
    setShowPhone({ ...showPhone, [row.id]: true });
    setShowEmail({ ...showEmail, [row.id]: false });

    const res = await dispatch(
      getEmployeeViewableStatusUpdate("Mobile", row, selectedDepartment, page),
    );
    if (res?.status === 200) {
    } else {
      showAlert("error", res);
    }
  };

  const viewExecutiveDetails = (row, name) => {
    let cname = name.replaceAll(" ", "-", name);
    navigate(`/executive-details/${row.id}/${cname}`);
  };
  const columns = [
    {
      title: "Executive Name",
      dataIndex: "fullname",
      fixed: "left",
      render: (text, row) => {
        return (
          <span
            className="namecol"
            onClick={() => viewExecutiveDetails(row, row.fullname)}
          >
            <Tooltip title={row.fullname}>
              {row.fullname?.length > 15
                ? `${row.fullname?.substring(0, 15)}...`
                : row.fullname}
            </Tooltip>
          </span>
        );
      },
    },
    {
      title: "Designation",
      dataIndex: "title",
      render: (record) => {
        return (
          <Tooltip title={record}>
            {record?.length > 15 ? `${record?.substring(0, 15)}...` : record}
          </Tooltip>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "emailId",
      render: (text, row) => {
        let checkLeadSubmitted = row?.leads?.isLead;
        return isAuthenticated ? (
          <>
            <div
              className={`tw-flex tw-items-center tw-gap-3 ${showEmail[row.key] && row.key === getEmployeeViewableData?.id && "tw-justify-between"}`}
            >
              {showEmail[row.key] && row.key === getEmployeeViewableData?.id ? (
                <>
                  <Tooltip title={getEmployeeViewableData?.emailId}>
                    <span>
                      {getEmployeeViewableData?.emailId?.length > 12
                        ? `${getEmployeeViewableData?.emailId.substring(0, 10)}...`
                        : getEmployeeViewableData?.emailId}
                    </span>
                  </Tooltip>
                  <div className="tw-bg-white tw-border tw-border-solid tw-border-border-secondary tw-rounded-lg tw-flex tw-items-center tw-p-1">
                    <CopyText
                      text={getEmployeeViewableData?.emailId}
                      content={
                        <Tooltip title="Copy Email">
                          <img
                            src={copy}
                            alt=""
                            style={{
                              height: "25px",
                              width: "25px",
                              padding: "5px",
                              maxWidth: "25px",
                            }}
                            className="cursor-pointer"
                          />
                        </Tooltip>
                      }
                    />

                    {isEmailSetupView && (
                      <>
                        <div
                          style={{
                            borderLeft: "1px solid #C7C7CC",
                            height: "22px",
                            margin: "0 6px 0 6px",
                          }}
                        ></div>
                        <EmailForm
                          recipientEmail={getEmployeeViewableData?.emailId}
                          empId={getEmployeeViewableData?.id}
                          payload={getEmployeeViewableData}
                          convertToLead={!row?.leads?.isLead}
                          onConvertToLead={() =>
                            postLeads(row?.leads, checkLeadSubmitted)
                          }
                        >
                          <Tooltip title="Send Email">
                            <div className="d-flex align-items-center justify-content-center">
                              <img
                                src={emailSync}
                                alt=""
                                style={{
                                  height: "23px",
                                  width: "23px",
                                  padding: "5px",
                                  maxWidth: "23px",
                                }}
                                className="tw-cursor-pointer"
                              />
                            </div>
                          </Tooltip>
                        </EmailForm>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <span
                    className="white-space-nowrap cursor-pointer"
                    onClick={() => updateEmailStatus(showEmail, row)}
                  >
                    View Email{" "}
                  </span>
                  <img
                    src={
                      row?.directDial?.isdownloadedEmail
                        ? viewEmailChecked
                        : viewEmail
                    }
                    alt=""
                    className="cursor-pointer"
                    onClick={() => updateEmailStatus(showEmail, row)}
                  />
                </>
              )}
            </div>
          </>
        ) : (
          <div
            className="tw-flex tw-items-center tw-gap-1.5 tw-cursor-pointer hover:tw-text-theme tw-text-xs tw-font-semibold tw-text-slate-700"
            onClick={() => setShowEmailPhoneModal(true)}
          >
            <span className="white-space-nowrap">View Email</span>
            <img src={viewEmail} alt="View Email" className="cursor-pointer tw-size-4" />
          </div>
        );
      },
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNo",
      render: (text, row) => {
        const number = getPartialPhoneNumber(text);
        return (
          <Tooltip title={!isAuthenticated ? "Click to view phone - Contact Us" : number}>
            <span
              className={!isAuthenticated ? "tw-cursor-pointer hover:tw-text-theme" : ""}
              onClick={!isAuthenticated ? () => setShowEmailPhoneModal(true) : undefined}
            >
              {number?.length > 12 ? `${number?.substring(0, 12)}...` : number}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Direct Dial/Mobile    ",
      dataIndex: "directDial",
      render: (record, row) => {
        return isAuthenticated ? (
          <>
            {row?.leads?.phoneNo && row?.leads?.phoneNo !== "" ? (
              <>
                {showPhone[row.id] &&
                row.key === getEmployeeViewableData?.id ? (
                  <div className="d-flex align-items-center gap-10">
                    <Tooltip title={getEmployeeViewableData?.phoneNo}>
                      <span className="phoneValue fs-12 pl-1 cursor-pointer">
                        {getEmployeeViewableData?.phoneNo}
                      </span>
                    </Tooltip>
                    <div className="email-grp-btn" style={{ padding: "0 3px" }}>
                      <CopyText
                        text={getEmployeeViewableData?.phoneNo}
                        content={
                          <Tooltip title="Copy Mobile No.">
                            <img
                              src={copy}
                              alt=""
                              style={{
                                height: "25px",
                                width: "25px",
                                padding: "5px",
                                maxWidth: "25px",
                              }}
                              className="cursor-pointer"
                            />
                          </Tooltip>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <img
                    src={
                      row?.directDial?.isdownloadedMobile
                        ? mobileChecked
                        : mobile
                    }
                    alt=""
                    onClick={() => updatePhoneStatus(showPhone, row)}
                  />
                )}
              </>
            ) : (
              <>-</>
            )}
          </>
        ) : (
          <div
            className="tw-flex tw-items-center tw-gap-1.5 tw-cursor-pointer hover:tw-text-theme tw-text-xs tw-font-semibold tw-text-slate-700"
            onClick={() => setShowEmailPhoneModal(true)}
          >
            <span className="white-space-nowrap">View Phone</span>
            <img src={mobile} alt="View Phone" className="cursor-pointer" />
          </div>
        );
      },
    },
    {
      title: "",
      dataIndex: "leads",
      render: (record) => {
        let checkLeadSubmitted = record?.isLead;
        return isAuthenticated ? (
          <Button
            type="text"
            loading={
              !Object.keys(submitLeadRes).length && addToLeads === record.id
                ? true
                : false
            }
            onClick={() => postLeads(record, checkLeadSubmitted)}
          >
            {checkLeadSubmitted ? (
              <Tooltip title="Added to lead">
                <UserCheck size={18} className="tw-text-emerald-600" />
              </Tooltip>
            ) : (
              <Tooltip title="Add to lead">
                <UserPlus size={18} className="tw-text-slate-600 hover:tw-text-theme" />
              </Tooltip>
            )}
          </Button>
        ) : (
          <Button
            type="text"
            loading={
              !Object.keys(submitLeadRes).length && addToLeads === record.id
                ? true
                : false
            }
            onClick={() => openInfoModel()}
          >
            <Tooltip title="Add to lead">
              <UserPlus size={18} className="tw-text-slate-600 hover:tw-text-theme" />
            </Tooltip>
          </Button>
        );
      },
    },
  ];

  const postLeads = async (record, isLeadSubmit) => {
    const { id } = getUserInfo();
    const { id: accountId } = getSubscriptionUserInfo();
    let leadPayload = {
      accountId: accountId,
      firstname: record.firstname,
      lastname: record.lastname,
      fullname: record.fullname,
      title: record.title,
      client: record.client,
      emailId: record.emailId,
      phoneNo: record.phoneNo,
      bio: record.bio,
      description: record.description,
      userId: id,
      employeeId: record.id,
      address: companyDetails?.address,
      companyId: companyDetails?.id,
      companyName: companyDetails?.name,
      industryId: companyDetails?.industry?.id,
      industryText: companyDetails?.industry?.name,
      empSizeId: companyDetails?.range?.name,
      city: companyDetails?.city,
      state: companyDetails?.state,
      country: companyDetails?.country,
      status: 11,
    };
    //status 11 for new lead
    if (!isLeadSubmit) {
      const res = await dispatch(submitLead(leadPayload, employeeIdsData));
      if (res?.status === 201) {
        dispatch(getEmployeeList(companyDetails?.id, null, page));
      } else {
        showAlert("error", res);
      }
      setAddToLeads(record.id);
    } else {
      navigate("/lead-details/" + isLeadSubmit);
    }
  };

  useEffect(() => {
    let data = [];
    let empIdsArr = [];
    employeeList?.forEach((record) => {
      empIdsArr = [...empIdsArr, record.id];
      data = [
        ...data,
        {
          key: record.id,
          id: record.id,
          fullname: record?.fullname
            ? record.fullname
            : record.firstname + " " + record.lastname,
          title: record?.title,
          emailId: record?.emailId,
          phoneNo: record?.company?.phoneNo,
          directDial: record,
          leads: record,
        },
      ];
    });

    setEmployeeData(data);
    setEmployeeIdsData(empIdsArr);
  }, [employeeList]);

  const openInfoModel = () => {
    if (isAuthenticated) {
      setOpenModal({ info: null, open: false });
    } else {
      setShowEmailPhoneModal(true);
    }
  };

  const redirectToSignup = () => {
    setOpenModal(false);
    navigate("/contact-us");
  };

  const closeInfoBeforeLogin = () => {
    setOpenModal(false);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      dispatch(storeSelectedExecutive(selectedRows));
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
    selectedRowKeys: selectedEmployeeList?.map((d) => d?.key),
  };

  return (
    <div>
      <Table
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        columns={columns}
        bordered={false}
        className="tw-custom-table tw-custom-table-no-border"
        dataSource={employeeData}
        pagination={false}
      />
      <CustomPagination
        total={totalCount}
        pageSize={PAGE_LENGTH}
        hidePerPage
        hideGoToPage
        noBorder
        onChange={(page) => {
          dispatch(getEmployeeList(companyDetails?.id, null, page - 1));
          searchParams.set("page", page - 1);
          navigate(`${location.pathname}?${searchParams.toString()}`);
        }}
      />

      <ViewEmailPhoneModal
        open={showEmailPhoneModal}
        onClose={() => setShowEmailPhoneModal(false)}
      />

      {openModal?.open && (
        <TrialModal
          openModal={openModal}
          closeModal={closeInfoBeforeLogin}
          redirectToSignup={redirectToSignup}
          redirect={true}
          isSubscriptionMissing
        />
      )}
    </div>
  );
};

export default KeyExecutives;
